import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import HoverComponent from '../../../_partials/HoverComponent/HoverComponent';
import { useSubmitMenuItem } from '../../../hooks/useSubmitMenuItem';
import BetaBadge from '@wix/da-ds/pkg/BetaBadge';
import s from './SubmitMenuItem.scss';
const SubmitMenuItem = ({ className, hoverComponentClassName, type, modalType, modalOptions, imageFileName, imageMarginBottom, imageMarginLeft, label, link, target, verificationAction, showDaProtect, showNewByTitle, role })=>{
    const { t } = useTranslation();
    const { onClick, href, biData } = useSubmitMenuItem({
        modalType,
        link,
        verificationAction,
        type,
        modalOptions
    });
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: c(className, s['new-container']),
        href: href,
        target: target,
        tabIndex: 0,
        onClick: onClick,
        biData: biData,
        isFakeButton: !onClick,
        role: role
    }, t(label), showNewByTitle && /*#__PURE__*/ React.createElement(BetaBadge, {
        badgeType: "new",
        className: s['new-badge'],
        size: "medium",
        variant: "green"
    }), imageFileName && /*#__PURE__*/ React.createElement(HoverComponent, {
        imageFileName: imageFileName,
        imageMarginBottom: imageMarginBottom,
        imageMarginLeft: imageMarginLeft,
        title: t(`${label}.title`),
        context: t(`${label}.context`),
        className: hoverComponentClassName,
        showDaProtect: showDaProtect
    }));
};
SubmitMenuItem.displayName = 'SubmitMenuItem';
export default SubmitMenuItem;

//# sourceMappingURL=SubmitMenuItem.js.map